<script setup lang="ts">
    import { useHipSpineUploadViewModel } from '@/views/case-settings/upload/hip-spine/useHipSpineUploadViewModel';
    import DicomMismatchModal from '@/views/case-settings/upload/shared/DicomMismatchModal.vue';
    import HipSpineUploadZone from '@/views/case-settings/upload/hip-spine/components/HipSpineUploadZone.vue';
    import HipSpineProgress from '@/views/case-settings/upload/hip-spine/components/HipSpineProgress.vue';

    const vm = useHipSpineUploadViewModel();
</script>

<template>
    <app-notification
        v-if="vm.isError"
        title="Upload Failed"
        :message="vm.error"
        variant="error"
        :animate-to="true"
    />

    <app-notification
        v-if="vm.hasUploaded"
        title="Your files were successfully uploaded"
        message="We will process your case now. Please return to the case list to track the progress of your case."
        variant="success"
        :animate-to="true"
    />

    <div
        v-if="vm.hasEnteredPatientData && !vm.isCaseDeemedUnsuitable"
        class="hip-spine-upload-container mb-2"
    >
        <HipSpineUploadZone hip-spine-position="Standing Sagittal" @add-file="vm.setStandingSagittal" />
        <HipSpineUploadZone hip-spine-position="Seated Sagittal" @add-file="vm.setSeatedSagittal" />
        <HipSpineUploadZone hip-spine-position="Lumbar Sagittal" @add-file="vm.setLumbarSagittal" />
    </div>

    <app-form-subtitle v-else-if="!vm.isCaseDeemedUnsuitable">
        Please enter all patient details, then return to this section to upload your X-rays.
    </app-form-subtitle>

    <app-form-actions>
        <app-button-primary
            class="ma-4 mr-12 float-end"
            :disabled="!vm.canStartProcessing"
            @click="vm.uploadAndStartProcessing"
        >
            Start Processing
        </app-button-primary>
    </app-form-actions>

    <DicomMismatchModal upload-type="xray-hip-spine" />
    <HipSpineProgress />
</template>

<style scoped lang="scss">
    .hip-spine-upload-container {
        display: flex;
        flex-direction: column;
        gap: 15px;
        padding: 0px 50px;
    }

    @media screen and (max-width: 850px) {
        .hip-spine-upload-container {
            padding: 0;
        }
    }
</style>
